<template>
  <div class="course-conflict-wrapper">
    <template
      v-for="(item, index) in list"
    >
      <Tooltip v-if="list.length" :key="index" placement="right" max-width="520">
        <div class="course-conflict-box" :class="{'border-class':type===2}">
          <CourseConflictComp
            :school-id="schoolId"
            :new-show="true"
            :item="item"
            :type="type"
            @updateStatus="handleUpdateStatus(item)"
          ></CourseConflictComp>
        </div>
        <template slot="content">
          <CourseTooltip
            :item="item"
            :type="type"
            :school-id="schoolId"
            @refresh="handleRefresh"
          ></CourseTooltip>
        </template>
      </Tooltip>
    </template>
    <ConflictModal v-model="conflictModal" :list="conflictModalData"></ConflictModal>
  </div>
</template>
<script>
import CourseTooltip from './CourseTooltip.vue';
import CourseConflictComp from './CourseConflictComp.vue';
import ConflictModal from './ConflictModal.vue';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
export default {
  components: {
    CourseTooltip,
    CourseConflictComp,
    ConflictModal
  },
  props: {
    type: {
      type: Number,
      default: 1
    },
    schoolId: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      conflictModal: false,
      conflictModalData: []
    };
  },
  methods: {
    handleRefresh() {
      this.$emit('refresh');
    },
    async handleUpdateStatus(item) {
      if (this.type === 2) {
        const res = await courseSchedulCenter.postCourseScheduleUpdateStatusApi({
          week: item.weekDate,
          timeId: item.timeId,
          teacherIds: item.teacherIdList,
          classroomId: item.classroomId,
          status: 1// 1 开展 2 未开展
        });
        if (res.status === 200 && res.message && res.message.length) {
          this.conflictModalData = res.message;
          this.conflictModal = true;
        } else if (res.status === 200) {
          this.$emit('refresh');
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.course-conflict-wrapper{
  display: flex;
  flex-flow: column;
  width: 100%;
  align-items: flex-start;
  .course-conflict-box{
    width: 100%;
    padding: 4px 10px;
    // min-height: 48px;
    cursor: pointer;
    &.border-class{
      border: 1px #ec808d dashed;
    }
  }
}

</style>
